import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  private readonly STORAGE_KEY = 'selectedDeliveryDetails';
  private cache = new Map<string, any>();

  location = {
    lat: 0,
    lon: 0,
  };

  setItem(setItem: any, data: any) {
    localStorage.setItem(setItem, data);
    this.cache.set(setItem, data);
  }

  getItem(getItem: any) {
    // Return cached value if available
    if (this.cache.has(getItem)) {
      return this.cache.get(getItem);
    }
    
    const value = localStorage.getItem(getItem);
    // Cache the value for future reads
    if (value !== null) {
      this.cache.set(getItem, value);
    }
    return value;
  }

  removeItem(remItem: any) {
    localStorage.removeItem(remItem);
    this.cache.delete(remItem);
  }

  removeAllItem() {
    localStorage.clear();
    this.cache.clear();
  }

  checkLength() {
    return localStorage.length;
  }

  setLocation(lat: any, lon: any) {
    this.location = { lat, lon };
  }

  getLocation() {
    return this.location;
  }

  getDeliveryDetails(): { pincode: number; latitude: number; longitude: number; stateName: string; districtName: string; cityName: string } | null {
    const data = localStorage.getItem(this.STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  }

  setDeliveryDetails(details: { pincode: number; latitude: number; longitude: number; stateName: string; districtName: string; cityName: string }) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(details));
  }

  // Helper method to get parsed JSON with caching
  getParsedItem<T>(key: string): T | null {
    const cached = this.cache.get(key);
    if (cached !== undefined) {
      return cached as T;
    }
    
    const value = localStorage.getItem(key);
    if (value) {
      try {
        const parsed = JSON.parse(value) as T;
        this.cache.set(key, parsed);
        return parsed;
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  // Helper method to set parsed JSON
  setParsedItem(key: string, value: any): void {
    const stringified = JSON.stringify(value);
    localStorage.setItem(key, stringified);
    this.cache.set(key, value);
  }

}
